import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlayCircleIcon } from 'lucide-react';
export function VideoSection() {
  const [isPlaying, setIsPlaying] = useState(false);
  const [showCTA, setShowCTA] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  useEffect(() => {
    if (!isPlaying || !iframeRef.current) return;
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== 'https://player.vimeo.com') return;
      try {
        const data = JSON.parse(event.data);
        if (data.event === 'ended') {
          setShowCTA(true);
        }
      } catch (e) {
        // Ignore parsing errors
      }
    };
    window.addEventListener('message', handleMessage);
    // Send a message to enable the ended event
    if (iframeRef.current?.contentWindow) {
      iframeRef.current.contentWindow.postMessage(JSON.stringify({
        method: 'addEventListener',
        value: 'ended'
      }), 'https://player.vimeo.com');
    }
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [isPlaying]);
  const handleGetTrial = () => {
    window.location.href = 'https://wellad.online/index.php/ai-voice-agent-onboarding/';
  };
  return <section id="video-demo" className="py-16 md:py-24 lg:py-32 bg-gradient-to-b from-gray-50 to-white" data-id="element-193">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-8" data-id="element-194">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-195">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-black mb-3 md:mb-4" data-id="element-196">
            See WellAd in Action
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-2xl mx-auto px-4" data-id="element-197">
            Watch how our AI receptionist transforms business communications
          </p>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative group flex justify-center" data-id="element-198">
          <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl bg-black max-w-md w-full" data-id="element-199">
            {!isPlaying ? <div onClick={() => setIsPlaying(true)} className="w-full cursor-pointer bg-gradient-to-br from-gray-100 to-gray-50" style={{
            aspectRatio: '9/16'
          }} data-id="element-200">
                <div className="flex flex-col items-center justify-center h-full p-6 md:p-8" data-id="element-201">
                  <motion.div whileHover={{
                scale: 1.1
              }} className="relative" data-id="element-202">
                    <div className="absolute inset-0 bg-indigo-500/20 rounded-full blur-2xl" data-id="element-203" />
                    <PlayCircleIcon size={60} className="text-indigo-600 relative z-10 md:w-20 md:h-20" data-id="element-204" />
                  </motion.div>
                  <h3 className="text-lg md:text-2xl font-bold text-black mt-4 md:mt-6 mb-2 md:mb-3 text-center" data-id="element-205">
                    WellAd AI Receptionist Demo
                  </h3>
                  <p className="text-sm md:text-base text-gray-600 text-center max-w-xs px-4" data-id="element-206">
                    See how our AI seamlessly handles customer calls, schedules
                    appointments, and captures leads
                  </p>
                </div>
              </div> : <div className="relative" data-id="element-207">
                <div className="w-full" style={{
              aspectRatio: '9/16'
            }} data-id="element-208">
                  <iframe ref={iframeRef} src="https://player.vimeo.com/video/1123051825?autoplay=1&title=0&byline=0&portrait=0" className="w-full h-full" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen data-id="element-209" />
                </div>
                <AnimatePresence data-id="element-210">
                  {showCTA && <motion.div initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0
              }} className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent flex items-end justify-center p-6 md:p-8" data-id="element-211">
                      <div className="text-center w-full" data-id="element-212">
                        <h3 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4" data-id="element-213">
                          Ready to Transform Your Business?
                        </h3>
                        <motion.button whileHover={{
                    scale: 1.05
                  }} whileTap={{
                    scale: 0.95
                  }} onClick={handleGetTrial} className="px-6 py-3 md:px-8 md:py-4 bg-white text-black rounded-full font-semibold hover:shadow-2xl transition-all text-sm md:text-base" data-id="element-214">
                          Get 1 Week Free Trial
                        </motion.button>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>}
          </div>
        </motion.div>
      </div>
    </section>;
}